const body = document.querySelector('body');
const popup = document.querySelector('.popup');
const overlay = document.querySelector('.overlay');
let scrollPosition = 0;

if (popup) {
  let closePopup = popup.querySelector('.close');

  if (localStorage.getItem("popup") === null) {
    popup.style.display = 'flex';
    overlay.style.display = 'block';
    enable()
  }

  if (closePopup) {
    closePopup.addEventListener("click", () => {
      popup.style.display = 'none';
      overlay.style.display = 'none';
      localStorage.setItem('popup', 'true');
      disable()
    });
  }

  if (localStorage.getItem("popup") === 'true') {
    popup.style.display = 'none';
    overlay.style.display = 'none';
    disable()
  }
}

function enable() {
  scrollPosition = window.pageYOffset;
  body.style.overflow = 'hidden';
  body.style.position = 'fixed';
  body.style.top = `-${scrollPosition}px`;
  body.style.width = '100%';
}

function disable() {
  body.style.removeProperty('overflow');
  body.style.removeProperty('position');
  body.style.removeProperty('top');
  body.style.removeProperty('width');
  window.scrollTo(0, scrollPosition);
}
